import Cookies from "js-cookie"
import React from "react"
import { useTranslation } from "react-i18next"
import useMedia from "@/common/hooks/use_media"
import tailwindTheme from "@/common/styles/theme.module.css"
import type Sign from "@/signomatic/app/sign"
import RowButton from "@/signomatic/components/row_button"
import ResetIcon from "@/skylticons/restart"

interface ResetButtonProps {
  sign: Sign
  showLabel?: boolean
  buttonClasses?: string
}

const ResetButton: React.FC<ResetButtonProps> = ({ sign, showLabel, buttonClasses }) => {
  const { t } = useTranslation()
  const desktop = useMedia(`(min-width: ${tailwindTheme.screensLg})`)

  return (
    <RowButton
      id="restart"
      onClick={() => {
        if (confirm(t("toolbox.reset_confirm"))) {
          sign.clear()
          Cookies.set("reset_tooltip_closed", "true")
        }
      }}
      className={buttonClasses}
      data-gtm="restart"
    >
      <ResetIcon />
      {desktop && <span className="paragraph-xs mb-0">{t("toolbox.restart")}</span>}
      {showLabel && <span>{t("toolbox.restart")}</span>}
    </RowButton>
  )
}

export default ResetButton
